import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idToken: null,
  accessToken: null,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthDetails(state, action) {
      state.idToken = action.payload?.idToken || null;
      state.accessToken = action.payload?.accessToken || null;
      state.user = action.payload?.user || null;
    },
    clearAuthDetails(state) {
      state.idToken = null;
      state.accessToken = null;
      state.user = null;
    },
  },
});

export const { setAuthDetails, clearAuthDetails } = authSlice.actions;
export default authSlice.reducer;
